import { CopyOutlined, EditOutlined, DeleteOutlined } from "@ant-design/icons";
import { Tag, Tooltip } from "antd";
import React, { useEffect } from "react";
import {
  Button,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Card,
} from "reactstrap";
import toast from "react-hot-toast";
import "react-toastify/dist/ReactToastify.css";
import { formatDatePaymentLink } from "../utils/script/indexUtils";
import "../utils/detailsModal.css";

const DetailLinkModal = ({ modalDetail, setModalDetail, toggle, linkSelected, formattingDate }) => {

  const MAXLENGTH_PAYMENTLINK = 60;
  const { paymentLink, amount, type, transactionCreatedAt, description, startDate, paymentStatus, clientEmail, paymentLinkExpiration } = linkSelected || {};

  const handleCopyLink = () => {
    if (!paymentLink) {
      toast.info("Aucun lien à copier");
    } else {
      navigator.clipboard.writeText(paymentLink);
      toast.success("Lien copié avec succès");
    }
  };

  const truncatePaymentLink = (link) => {
    if (link.length <= MAXLENGTH_PAYMENTLINK) return link;
    return link.slice(0, MAXLENGTH_PAYMENTLINK / 2) + '...' + link.slice(-MAXLENGTH_PAYMENTLINK / 2);
  }

  const formattedDate = (timestamp) => {
    console.log(timestamp);
    const date = new Date(timestamp);
    return (
      <span>
        {
          date.toLocaleDateString('fr-FR', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
          })
        }
      </span>
    );
  }

  const formattedArrayDate = (startDate) => {
    const date = new Date(
      Date.UTC(
        startDate[0], // année
        startDate[1] - 1, // mois (0-indexé)
        startDate[2], // jour
        startDate[3], // heure
        startDate[4], // minute
        startDate[5]  // seconde
      )
    );
    const timestamp = date.getTime() - startDate[6];
    return formattedDate(timestamp);
  }

  useEffect(() => {
    console.log(linkSelected)
  }, [linkSelected]);
  return (
    <>
      <ModalHeader className="p-3" toggle={toggle}>
        <span className="modal-title">Lien de paiement</span>
      </ModalHeader>
      <ModalBody>
        <Row>
          <Col lg={6}>
            <Card className="lnk-card-detail">
              <div className="lnk-block">
                <p className="lnk-label">Description</p>
                <p className="lnk-description">
                  {description || "Aucune description fournie."}
                </p>
              </div>

              <div className="lnk-block">
                <p className="lnk-label">Montant encaissé</p>
                <p className="lnk-amount">{new Intl.NumberFormat('fr-FR', {
                  style: 'currency',
                  currency: 'XOF'
                }).format(amount)}</p>
              </div>

              <div className="lnk-block">
                <p className="lnk-label">Statut du paiement</p>
                <span
                  className={`lnk-status ${paymentStatus === "SUCCESS" ? "lnk-success" : "lnk-danger"
                    }`}
                >
                  {paymentStatus == "SUCCESS" ? "Payé" : "Non payé" || "Indéfini"}
                </span>
              </div>

              <div className="lnk-block">
                <p className="lnk-label">Date de création du lien</p>
                <p className="lnk-date lnk-value">{formatDatePaymentLink(startDate)}</p>
              </div>

            </Card>
          </Col>
          <Col lg={6} className="mt-2">
            <Card className="lnk-card-detail">
              <div className="lnk-block">
                <p className="lnk-label">Lien</p>
                <div className="lnk-copy-container">
                  <input
                    type="text"
                    readOnly
                    value={truncatePaymentLink(paymentLink) || "Aucun lien"}
                    className="lnk-copy-input"
                  />
                  <Tooltip title="Copier le lien">
                    <CopyOutlined
                      className="lnk-copy-icon"
                      onClick={handleCopyLink}
                    />
                  </Tooltip>
                </div>
              </div>

              <div className="lnk-block">
                <p className="lnk-label">Type de lien</p>
                <p className="lnk-value">{type || "Non spécifié"}</p>
              </div>

              <div className="lnk-block">
                <p className="lnk-label">Email du destinataire</p>
                <p className="lnk-value">
                  {clientEmail ? clientEmail : "Non défini"}
                </p>
              </div>

              <div className="lnk-block">
                <p className="lnk-label">Date d'expiration du lien</p>
                <p className="lnk-value">{formatDatePaymentLink(paymentLinkExpiration)}</p>
              </div>
            </Card>
          </Col>
        </Row>
      </ModalBody>
      <div className="mt-2">
        <Button color="secondary" onClick={() => setModalDetail(false)}>
          Fermer
        </Button>
      </div>
    </>
  );
};

export default DetailLinkModal;
